/**
 * Consentement aux cookies de mesure d'audience — règles CNIL (29/10/2026).
 *
 * Relevé en production le 29/10/2026 (navigateur neuf, www.gively.fr) : en
 * « Consent Mode avancé », gtag.js se chargeait AVANT tout choix et continuait
 * d'envoyer des requêtes à analytics.google.com, www.google.com et
 * stats.g.doubleclick.net (identifiant client, résolution d'écran) APRÈS un
 * clic sur « Refuser ». Aucun cookie n'était déposé, mais des informations du
 * terminal partaient chez Google sans consentement (loi Informatique et
 * Libertés, art. 82).
 *
 * Décision : « mode de base » (doc Google, « Présentation du mode
 * Consentement », lue le 29/10/2026 : les balises sont bloquées tant que
 * l'utilisateur n'a pas répondu, aucune donnée ne part avant) — gtag.js n'est
 * chargé qu'après « Accepter ». Le choix est conservé 6 mois, durée
 * recommandée par la CNIL, puis redemandé.
 *
 * `public/index.html` ne peut pas importer ce module (script inline exécuté
 * avant le bundle) : il en reprend la même règle, et la garde
 * `consentementCookies.test.js` vérifie que les deux restent alignés.
 */

export const CLE_CONSENTEMENT = "gively_cookie_consent";

// 6 mois (CNIL, recommandation sur les cookies : conservation du choix,
// acceptation comme refus). 183 jours couvrent n'importe quels six mois.
export const DUREE_CHOIX_MS = 183 * 24 * 60 * 60 * 1000;

/**
 * Lit le choix enregistré. Renvoie "accepte", "refuse" ou null quand il n'y a
 * pas de choix valable (absent, illisible, sans date, ou plus vieux que 6 mois)
 * — null veut dire : redemander, et ne rien charger.
 */
export function lireConsentement(brut, maintenant = Date.now()) {
  if (!brut) return null;
  let choix;
  try { choix = JSON.parse(brut); } catch (_) { return null; }
  if (!choix || typeof choix !== "object") return null;
  const date = Date.parse(choix.date);
  if (!Number.isFinite(date) || maintenant - date > DUREE_CHOIX_MS) return null;
  if (choix.accepted === true) return "accepte";
  if (choix.accepted === false) return "refuse";
  return null;
}

/**
 * Efface les cookies Google Analytics (_ga, _ga_<ID>) déposés après une
 * acceptation antérieure : retirer son consentement doit être aussi effectif
 * que le donner. Les cookies GA sont posés sur le domaine racine
 * (.gively.fr) ; on efface aussi la variante sans domaine, par précaution.
 */
export function effacerCookiesMesure(doc = typeof document !== "undefined" ? document : null) {
  if (!doc || typeof doc.cookie !== "string") return [];
  const noms = doc.cookie
    .split(";")
    .map((c) => c.split("=")[0].trim())
    .filter((nom) => nom === "_ga" || nom.startsWith("_ga_") || nom === "_gid");
  const hote = (doc.location && doc.location.hostname) || "";
  const racine = hote.split(".").slice(-2).join(".");
  noms.forEach((nom) => {
    const expire = `${nom}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
    doc.cookie = expire;
    if (racine) doc.cookie = `${expire}; domain=.${racine}`;
  });
  return noms;
}
